// GET /white-labels/:id/templates devolve UMA linha por VERSÃO (mesmo
// `id` de template, `version` diferente). Nos selects de associação de
// template a opção é identificada pelo uuid (`id`), então versões
// repetidas viram valores DUPLICADOS — o Radix Select concatena o texto
// de todas as opções de mesmo value no trigger (ex.: "Criação de Pedido
// @v6 @v5 …"), estourando o layout. Aqui reduzimos para UMA opção por
// template: a versão ATIVA, ou a maior versão quando nenhuma é ativa.
import type { NotificationCenterWhitelabelTemplate } from "@/types/notification-center"

export const dedupeTemplateOptionsByLatest = (
  templates: NotificationCenterWhitelabelTemplate[]
): NotificationCenterWhitelabelTemplate[] => {
  const byId = new Map<
    string,
    NotificationCenterWhitelabelTemplate
  >()

  for (const template of templates) {
    const chosen = byId.get(template.id)
    if (!chosen || preferOver(template, chosen)) {
      byId.set(template.id, template)
    }
  }

  return [...byId.values()]
}

// Candidato vence se é ativo (e o atual não), ou — em igualdade de
// "ativo" — se tem versão maior.
const preferOver = (
  candidate: NotificationCenterWhitelabelTemplate,
  current: NotificationCenterWhitelabelTemplate
): boolean => {
  if (candidate.active !== current.active) {
    return candidate.active
  }
  return candidate.version > current.version
}
